import React, { useMemo } from "react";
import { Box, Typography, useTheme } from "@mui/material";
import {
  CardNumberElement,
  CardExpiryElement,
  CardCvcElement,
} from "@stripe/react-stripe-js";
import { StyledCardFieldWrapper } from "./AddPayment.styles";

export type StripeSplitFieldsProps = {
  onChange?: (event: any, field: "number" | "expiry" | "cvc") => void;
  className?: string;
  style?: React.CSSProperties;
};

const StripeSplitFields: React.FC<StripeSplitFieldsProps> = ({ onChange }) => {
  const theme = useTheme();

  const stripeStyle = useMemo(
    () => ({
      base: {
        color: theme.palette.text.primary,
        backgroundColor: theme.palette.background.default,
        "::placeholder": { color: theme.palette.text.secondary },
      },
      invalid: {
        color: theme.palette.error.main,
        "::placeholder": { color: theme.palette.error.light },
      },
    }),
    [theme]
  );

  const handleChange = (field: "number" | "expiry" | "cvc") => (event: any) => {
    if (onChange) onChange(event, field);
  };

  return (
    <Box display="flex" flexDirection="column" gap={4} width="100%">
      <Box display="flex" flexDirection="column" gap={2} width="100%">
        <Typography variant="body2">Numéro de carte</Typography>
        <StyledCardFieldWrapper>
          <CardNumberElement
            options={{ style: stripeStyle, showIcon: true, disableLink: true }}
            onChange={handleChange("number")}
          />
        </StyledCardFieldWrapper>
      </Box>
      <Box display="flex" gap={2} width="100%">
        <Box flex={1} display="flex" flexDirection="column" gap={2}>
          <Typography variant="body2">Date d'expiration</Typography>
          <StyledCardFieldWrapper>
            <CardExpiryElement
              options={{ style: stripeStyle }}
              onChange={handleChange("expiry")}
            />
          </StyledCardFieldWrapper>
        </Box>

        <Box flex={1} display="flex" flexDirection="column" gap={2}>
          <Typography variant="body2">CVC</Typography>
          <StyledCardFieldWrapper>
            <CardCvcElement
              options={{ style: stripeStyle }}
              onChange={handleChange("cvc")}
            />
          </StyledCardFieldWrapper>
        </Box>
      </Box>
    </Box>
  );
};

export default StripeSplitFields;
